const getters = {
  auth: (state: any) => state.auth,
  language: (state: any) => state.language,
  wallet: (state: any) => state.wallet,
  history: (state: any) => state.history,
  notification: (state: any) => state.notification,
  guide: (state: any) => state.guide,
  transaction: (state: any) => state.transaction,
};

export default getters;
